<template>
  <div>
    <input :id="'file_input'+id" type="file" @change="handleChangeFile" style="display: none;"
           :accept="fileTypeAll ? '' : 'application/msword, .docx, application/vnd.ms-excel, .xlsx, application/vnd.ms-powerpoint,\n'+
'text/plain, application/pdf, image/png, image/gif, image/jpeg, .hwp, .csv'"
           :disabled="readonly">
    <template-file-upload-check-list
      v-if="type === 'check_list'"
      :file-list="fileList"
      :visible-title="visibleTitle"
      :readonly="readonly"
      @handleClickAddFileButton="handleClickAddFileButton"
      @handleRemoveFile="handleRemoveFile"
    ></template-file-upload-check-list>

    <template-file-upload-check-list-col
      v-if="type === 'check_list_col'"
      :is-show-title="isShowTitle"
      :file-list="fileList"
      :readonly="readonly"
      @handleClickAddFileButton="handleClickAddFileButton"
      @handleRemoveFile="handleRemoveFile"
    ></template-file-upload-check-list-col>

    <template-file-upload-gallery
      v-if="type === 'gallery'"
      :is-show-title="isShowTitle"
      :file-list="fileList"
      :readonly="readonly"
      :multi-stage="multiStage"
      :is-print="isPrint"
      @handleClickAddFileButton="handleClickAddFileButton"
      @handleRemoveFile="handleRemoveFile"
    ></template-file-upload-gallery>

  </div>
</template>

<script>
import TemplateFileUploadCheckList from '@/views/modules/template/TemplateFileUploadCheckList'
import TemplateFileUploadCheckListCol from '@/views/modules/template/TemplateFileUploadCheckListCol'
import TemplateFileUploadGallery from '@/views/modules/template/TemplateFileUploadGallery'
export default {
  name: 'FileUploadModule',
  components: {
    TemplateFileUploadGallery,
    TemplateFileUploadCheckListCol,
    TemplateFileUploadCheckList},
  props:{
    type:{
      type: String,
      default: 'check_list'
    },
    fileTypeAll: Boolean,
    isShowTitle:Boolean,
    isPrint:Boolean,
    visibleTitle:{
      type:Boolean,
      default: true
    },
    readonly:Boolean,
    id:String,
    value:Array, //{ id:0, fileName:'test1.txt', fileSize:1234, path:'', thumb:'' }
    multiStage: Number
  },
  watch: {
    value: {
      deep: true,
      handler (value) {
        this.fileList = value
      }
    }
  },
  data () {
    return {
      fileList:[]
    }
  },
  created () {
    if (this.value) {
      this.fileList = this.value
    }
  },
  methods:{
    async file_upload (files) {
      if (files.length > 0) {
        await this.$store.dispatch('file/FILE_UPLOAD', files[0])
        this.addFile(this.$store.state.file.uploadedFile)
      }
      const inputFile = document.getElementById(`file_input${this.id}`)
      inputFile.value = ''
    },

    addFile (fileObject) {
      if (fileObject) {
        this.fileList.push(fileObject)
      } else {
      }

      this.handleFileList(this.fileList)
    },

    handleClickAddFileButton () {
      const inputFile = document.getElementById(`file_input${this.id}`)
      inputFile.click()
    },

    handleChangeFile (event) {
      this.file_upload(event.target.files)
    },

    handleRemoveFile (fileList) {
      for (const file of fileList) {
        this.fileList.remove(file)
      }
      const inputFile = document.getElementById(`file_input${this.id}`)
      inputFile.value = ''

      this.handleFileList(this.fileList)
    },

    handleFileList (files) {
      this.$emit('input', files)
    }
  }
}
</script>

<style scoped>

</style>
